import { createReducer } from '@reduxjs/toolkit';
import { getUserInformationSuccessResponse } from 'actionCreators/user';
import { resetPrimaryApplicantInfo } from 'actionCreators/config';

const initialState = {
  emailAddress: null,
  userName: null
};

const userInformationReducer = createReducer(initialState, (builder) => {
  builder.addCase(getUserInformationSuccessResponse, (state, action) => {
    return {
      ...state,
      emailAddress: action.payload.contact_details.email,
      userName: action.payload.user_name
    };
  });

  builder.addCase(resetPrimaryApplicantInfo, () => {
    return initialState;
  });
});
export { userInformationReducer };
